<script>

	import { v4 as uuid } from 'uuid';

	import Tooltip from './Tooltip.svelte';

	import { helpTooltip } from '../lib/stores.js';

	export let text;

	let tooltipRef = uuid();

	let openTimer;

	function openTooltip(e, delay) {
		clearTimeout(openTimer);
		const help = e.target.closest('.help');
		if (delay == undefined) {
			delay = 600;
		}
		openTimer = setTimeout(function (){
			$helpTooltip = tooltipRef;
		}, delay);
	}

	function closeTooltip(e) {
		clearTimeout(openTimer);
		$helpTooltip = null;
	}

	function toggleTooltip(e) {
		if ($helpTooltip && $helpTooltip.ref == tooltipRef) {
			closeTooltip();
		} else {
			openTooltip(e, 0);
		}
	}

</script>

<style>
	.help {
		display: inline-block;
		position: relative;
		width: 1em;
		height: 1em;
		left: 0;
		top: -0.05em;
	}
	.help svg {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	.help path {
		fill: var(--blend-60);
	}
</style>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<svelte:body on:click={closeTooltip}/>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<span class="help" on:mouseenter={openTooltip} on:mouseleave={() => {clearTimeout(openTimer)}} on:click|stopPropagation={toggleTooltip}>
	<slot>
		<svg viewBox="0 0 56 56"><path d="M56 28c0 15.46-12.54 28-28 28s-28-12.54-28-28 12.54-28 28-28 28 12.54 28 28zm-28-24c-13.25 0-24 10.75-24 24s10.75 24 24 24 24-10.75 24-24-10.75-24-24-24z"/><path d="M31.61 9.61c3.05 0 3.95 1.77 3.95 3.79 0 2.52-2.02 4.86-5.47 4.86-2.89 0-4.26-1.45-4.18-3.85 0-2.02 1.69-4.8 5.7-4.8zM24.01 46.39c-2.09 0-3.61-1.27-2.15-6.82l2.39-9.86c.41-1.58.48-2.21 0-2.21-.62 0-3.33 1.09-4.93 2.16l-1.04-1.7c5.07-4.23 10.89-6.71 13.38-6.71 2.09 0 2.43 2.46 1.39 6.26l-2.74 10.36c-.49 1.83-.28 2.46.21 2.46.63 0 2.67-.76 4.69-2.34l1.18 1.58c-4.92 4.93-10.3 6.82-12.38 6.82z"/></svg>
	</slot>
	{#if $helpTooltip && $helpTooltip == tooltipRef}
		<Tooltip bind:tooltip={$helpTooltip}>
			{text}
		</Tooltip>
	{/if}
</span>